export const GET_MERCURY_JOB = "GET_MERCURY_JOB";
export const UPDATE_MERCURY_JOB = "UPDATE_MERCURY_JOB";
export const GET_RHAPSODY_JOB = "GET_RHAPSODY_JOB";
export const CREATE_MERCURY_JOB = "CREATE_MERCURY_JOB";
